<template>
  <div>
    <div class="panel-title">
      {{resultsLengthText}} found for "
      <b>{{searchMessage.toUpperCase()}}</b>"
    </div>
    <table class="table table-striped bank-accounts table-fundings" id="results">
      <thead>
        <tr>
          <th>Note number</th>
          <th>CUSIP number</th>
          <th>Account number</th>
          <th>Account name</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(note, index) in sortedNotes" :key="`${index}-note-${note.noteId}`">
          <td>{{note.noteId}}</td>
          <td>{{note.cusip}}</td>
          <td>{{note.account.accountId}}</td>
          <td>{{note.account.accountName}}</td>
          <td>
            <button
              type="button"
              class="btn btn-details btn-outline"
              v-on:click="goToAccountDetail(note)"
            >Account details</button>
            <button
              type="button"
              class="btn btn-details btn-outline"
              v-on:click="goToNoteDetails(note)"
            >Note details</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { getAccounTypeProperties } from '@/util';

export default {
  name: 'SearchByCUSIPResults',
  data() {
    return {};
  },
  props: {
    results: {
      type: Object,
      required: true,
      default: {},
    },
    searchMessage: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    notes() {
      return this.results.notes;
    },
    resultsLengthText() {
      return `${this.notes.length} ${
        this.notes.length > 1 ? 'results' : 'result'
      }`;
    },
    sortedNotes() {
      return this.notes;
    },
  },
  methods: {
    getPrimaryInvestor(note) {
      return note.account.primaryInvestor;
    },
    getNameAndUserId(note) {
      const user = this.getPrimaryInvestor(note);
      return {
        userId: user.id,
        name: user.firstName,
        lastName: user.lastName,
      };
    },
    goToNoteDetails(note) {
      const { userId, name } = this.getNameAndUserId(note);

      const routeParams = {
        name: 'NoteDetail',
        params: {
          noteId: note.id,
          userId,
          name,
        },
      };

      this.$router.push(routeParams);
    },
    goToAccountDetail(note) {
      const { userId, name } = this.getNameAndUserId(note);
      const { account } = note;
      const accountTypeProperties = getAccounTypeProperties(
        account.accountType,
      );

      const routeParams = {
        name: accountTypeProperties.component,
        params: {
          accountId: account.id,
          userId,
          name,
        },
      };

      this.$router.push(routeParams);
    },
  },
};
</script>

<style scoped>
.btn-details {
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// SearchByNoteNumberOrCUSIPResults.vue?248cb154